import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export interface StagedWidgetDimensions {
  width: string;
  height: string;
}

interface WidgetWidthHeightPayload {
  id: string;
  updateWidth: boolean;
  updateHeight: boolean;
}

interface StageWidgetDimensionsPayload extends StagedWidgetDimensions {
  id: string;
}

interface UpdateWidgetProps {
  widgetWidthHeight: WidgetWidthHeightPayload;
  stagedWidgetDimensions: Record<string, StagedWidgetDimensions>;
}

const initialState: UpdateWidgetProps = {
  widgetWidthHeight: {
    id: '',
    updateWidth: false,
    updateHeight: false,
  },
  stagedWidgetDimensions: {},
};

const updateWidthHeightSlice = createSlice({
  name: 'updateChartWidthHeight',
  initialState,
  reducers: {
    setWidgetWidthHeight(state, action: PayloadAction<WidgetWidthHeightPayload>) {
      state.widgetWidthHeight = action.payload;
    },
    stageWidgetDimensions(state, action: PayloadAction<StageWidgetDimensionsPayload>) {
      const { id, width, height } = action.payload;
      state.stagedWidgetDimensions[id] = { width, height };
    },
    clearStagedWidgetDimensions(state) {
      state.stagedWidgetDimensions = {};
    },
  },
});

export const { setWidgetWidthHeight, stageWidgetDimensions, clearStagedWidgetDimensions } = {
  ...updateWidthHeightSlice.actions,
};

export default updateWidthHeightSlice.reducer;

export const selectWidgetChartHeight = (state: RootState) => state.rootReducer.updateWidthHeight;
export const selectStagedWidgetDimensions = (state: RootState) =>
  state.rootReducer.updateWidthHeight.stagedWidgetDimensions;
